export const inp = {
  width: "100%",
  padding: "10px 14px",
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: 10,
  color: "#fff",
  fontSize: 14,
  fontFamily: "'DM Sans',sans-serif",
  outline: "none",
  boxSizing: "border-box",
};

export const lbl = {
  display: "block",
  fontSize: 11,
  color: "#666",
  marginBottom: 5,
  fontFamily: "'Space Mono',monospace",
  textTransform: "uppercase",
  letterSpacing: 1.2,
};

export const btn = {
  border: "none",
  cursor: "pointer",
  borderRadius: 10,
  fontFamily: "'DM Sans',sans-serif",
  fontWeight: 600,
  transition: "all 0.15s",
};
